import axios from "axios";
import { API_DOMAIN } from "../utils/constants";
import { chunkData } from "../utils/chunkData";

export const chunkAndUploadData = async (category, jsonData, feedbackType, source) => {
  const cleanData = trimTrailingSpacesFromKeysInArray(jsonData);
  const chunks = chunkData(cleanData, 20);
  const collectedResponse = [];
  for (let index = 0; index < chunks.length; index++) {
    const chunk = chunks[index];
    const response = await uploadReport(category, chunk, feedbackType, source);
    collectedResponse.push(...response.data.response);
  }

  return collectedResponse;
};
export const uploadReport = async (category, jsonData, feedbackType, source) => {
  return await axios.post(
    `${API_DOMAIN}/upload-report?category=${category}&feedbackType=${feedbackType}&source=${source}`,
    {
      data: jsonData,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

function trimTrailingSpacesFromKeysInArray(arr) {
  return arr.map((obj) =>
    Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.trim(),
        value,
      ])
    )
  );
}
